import { getQueryClient } from "@/app/react-query/query-client"
import type { NftMiniature } from "@anaconda/core/nft/types"

function isObjectRecord(
  value: unknown,
): value is Record<string | number | symbol, unknown> {
  return typeof value === "object" && value !== null
}

function hasStringProperty<TKey extends string>(
  value: unknown,
  key: TKey,
): value is Record<TKey, string> {
  return isObjectRecord(value) && typeof value[key] === "string"
}

export function invalidateBoughtNftQueries(nft: NftMiniature) {
  const queryClient = getQueryClient()

  void queryClient.invalidateQueries({
    predicate: (query) => {
      const [scope, typeOrInput, input] = query.queryKey

      if (
        scope === "collections" &&
        typeOrInput === "floorItem" &&
        hasStringProperty(input, "collectionId")
      ) {
        return input.collectionId === nft.collection.id
      }

      if (scope === "nft" && hasStringProperty(typeOrInput, "id")) {
        return typeOrInput.id === nft.id
      }

      return false
    },
  })
}
